export default {
  // used for FCC
  PERMISSION: '/unifideUserInfo',
  USERLIST: '/userlist',

  CLIENTINFO: '/asyncClientInfo',
  INVITEUSER: '/inviteUser',
  GETUSERALLINFO: '/user',

  USER: '/user',
  USERANALYTICS: '/report/detail',
  USERREPORTINFO: '/report/info',
  ACTIVITY: '/activity',

  UPLOADIMAGE: '/image',
  FIRM_LIST: '/firmSetup/firm/list',
  FIRM_INFO: '/firmSetup',
  IMPERSONATION: '/samlImpersonation',

  TEAM: '/team',
  TEAMLIST: '/team/list',
  TEAM_MEMBER_UPLOAD: '/image/upload',

  PERMISSION_LIST: '/unifide/user/permission/list',
  PERMISSION_UPDATE: '/unifide/user/permission',

  MESSAGE_LIST: '/message/list',
  DELETE_MESSAGE: 'message/delete',
  SEND_MESSAGE: '/message/send',
  MESSAGE_OPERATE: '/message',
  MESSAGE_FILEUPLOAD: '/message/file',
  BULKUPLOAD: '/bulkUpload',
  BULKUPLOAD_LIST: '/bulkUpload/list',
  DATAEXPORT: '/data/export',
  DATAEXPORT_LIST: '/data/export/list',
  SUMMARY: '/report/summary',
  REPORT_ACTIVE: '/report/active',
  MAINTENANCE: '/maintenance',
};
